import { useEffect, type MutableRefObject } from 'react'
import type { GridApi, GridColumn } from '@/components/grid/types'
import type { HydraulicTreeRow } from './types'

interface UseColumnVisibilityArgs {
  availableColumns: { field: string }[]
  columns: GridColumn<HydraulicTreeRow>[]
  bulkEditMode: boolean
  gridApiRef: MutableRefObject<GridApi<HydraulicTreeRow> | null>
}

/**
 * Which columns show.
 *
 * The pipe list has no column picker — every column defined for it is part of
 * the layout — so the only column that comes and goes is `action`, which
 * carries the row's bulk-edit controls. The rest are pushed visible on every
 * pass, which also clears any layout an earlier build's picker left behind.
 */
const useColumnVisibility = ({
  availableColumns,
  columns,
  bulkEditMode,
  gridApiRef,
}: UseColumnVisibilityArgs) => {
  useEffect(() => {
    const api = gridApiRef.current
    if (!api) return
    availableColumns.forEach((col) => {
      api.setColumnsVisible(
        [col.field],
        col.field === 'action' ? bulkEditMode : true,
      )
    })
  }, [availableColumns, bulkEditMode, columns, gridApiRef])
}

export default useColumnVisibility
